import React, {useContext, useEffect} from 'react';
import trypiContext from '../../context/trypiContext';
import './DashboardContainerDefinitionPanel.css';


const DashboardContainerDefinitionPanel = (props) => {
    const {pisaasFetchEnvInfoByInstance, updatePisaasFetchEnvInfoByInstance} = useContext(trypiContext);

    useEffect(() => {
        const timerId = setTimeout(() => {
            updatePisaasFetchEnvInfoByInstance(props.serviceName, props.region);
        });
        return () => clearTimeout(timerId);
        // eslint-disable-next-line
    }, []);
    const handleRefresh = () => {
        updatePisaasFetchEnvInfoByInstance(props.serviceName, props.region);
    }

    const DisplayDataRow = () => {
        return (
            Object.keys(pisaasFetchEnvInfoByInstance.data.environment_variables).map((key) => (

                    <tr key={key} className={"container-def-row"}>
                        <th className={"container-def-header"}>{key}</th>
                        <td className={"container-def-data"}>{pisaasFetchEnvInfoByInstance.data.environment_variables[key]}</td>
                    </tr>

                )
            )
        )
    }

    if (pisaasFetchEnvInfoByInstance.loading) {
        return (<div><p>loading...</p></div>)
    } else {
        return (
            <div className={"container-def-table"}>
                <hr/>
                <p>The information below is the current task definition environment settings for {props.serviceName}-dashboard</p>
                <button onClick={handleRefresh}>Refresh Dashboard Task Definition</button>
                <table className={"container-def-table"}>
                    <thead>
                    <tr className={"container-def-row"}>
                        <th className={"container-def-header"}>Key</th>
                        <th className={"container-def-header"}>Value</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr className={"container-def-row"}>
                            <th className={"container-def-header"}>Image</th>
                            <td className={"container-def-data"}>{pisaasFetchEnvInfoByInstance.data.image}</td>
                        </tr>
                        <DisplayDataRow/>
                    </tbody>
                </table>
            </div>
        )
    }
}

export default DashboardContainerDefinitionPanel;